<script>
import Button from '@/components/button/Button.vue';
import { mapActions, mapState } from 'vuex';
import moment from 'moment/moment';
import BillList from '@/views/bill/BillList.vue';

export default {
  name: 'OrderPlaced',
  components: {
    BillList,
    Button,
  },
  filters: {
    cutoffTimeFix(time) {
      return moment(time, 'MM/DD/YYYY HH:mm:ss').format('HH:mm:ss');
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState('send', ['sendInfo']),
  },
  mounted() {},
  methods: {
    bindFedexNumber() {
      this.loading = true;
      let orderNum = this.sendInfo.orderNum;
      this.fetchOrderMainDraftInfo(orderNum)
        .then(res => {
          if (!res.success) {
            this.loading = false;
            this.$Message.error({
              content: res.message,
              duration: 5,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downLoadPdf(truckNum) {
      window.open(`/order/label/res-id-${truckNum}.pdf`);
    },
    newWindow(url) {
      window.open(url, '_blank');
    },
    ...mapActions('send', ['fetchOrderMainDraftInfo']),
  },
};
</script>

<template>
  <div class="order-placed">
    <div v-if="!sendInfo.truckNum || sendInfo.truckNum.length === 0">
      <p class="title" style="text-align: center">
        Oops, Something went wrong! Please continue to try again later.
        <br />
        If you still can't create the order after multiple attempts, please contact customer service.
      </p>
      <p class="step-desc" style="text-align: center">
        <span>Order time: {{ sendInfo.orderTime }}</span>
        <span>Order#: {{ sendInfo.orderNum }}</span>
      </p>
      <p class="step-desc" style="width: 200px; margin: 10px auto">
        <Button size="large" class="btn" @click="bindFedexNumber()">
          Get shipping label
        </Button>
      </p>
    </div>
    <template v-else>
      <p class="title">
        Order placed！Please follow the steps below to deliver the package to the FedEx staff
      </p>
      <p class="step-desc">
        <span>Order time: {{ sendInfo.orderTimeZdtStr }}</span>
        <span>Order#: {{ sendInfo.orderNum }}</span>
      </p>
      <div class="steps">
        <div class="step">
          <span class="f-number">1</span>
          <p class="title">Pack belongings</p>
          <p class="desc">Please sort your items and pack them, we provide you with packing suggestions</p>
          <a href="https://support.movingkite.com/hc/en-us/articles/4404704275611" target="_blank" class="btn info"
            >Packing advice ></a
          >
        </div>
        <div class="step">
          <span class="f-number">2</span>
          <p class="title">Affix FedEx labels</p>
          <p class="desc">
            We have sent {{ sendInfo.truckNum.length }} FedEx labels to your registered email address. You can also
            click the label button below to get the labels. Please print and affix to your box.
          </p>
          <ul class="box-status">
            <li class="box-item">
              <div v-for="(num, index) in sendInfo.truckNum" :key="num" class="row">
                <span class="num">#{{ index + 1 }}</span>
                <div class="content">
                  <div class="content-row">
                    <span class="tip">Tracking #</span>
                    <div class="number">
                      <span>{{ num }}</span>
                    </div>
                  </div>
                  <div class="content-row">
                    <Button size="large" class="btn" @click="downLoadPdf(num)">
                      <div><i-icon class="d-cion" type="md-download" />Label</div>
                    </Button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="step">
          <span class="f-number">3</span>
          <div class="title">
            <span>Send boxes</span>
            <span
              v-if="sendInfo.pickup"
              class="btn info"
              @click="newWindow('https://support.movingkite.com/hc/en-us/articles/4404707626779')"
            >
              Notes for pick up >
            </span>
          </div>
          <template v-if="sendInfo.pickup">
            <p class="desc">Please wait for FedEx staff to pick up the package</p>
          </template>
          <template v-else>
            <p class="desc">Please send the package to the FedEx locations nearby</p>
            <p class="btn info" @click="newWindow('https://local.fedex.com/en-us')">Find FedEx locations nearby ></p>
          </template>
          <ul v-if="sendInfo.pickup" class="pickup-status">
            <li class="pickup-item">
              <p class="title">Pick-up time</p>
              <p class="desc">{{ sendInfo.pickupTime }} - {{ sendInfo.cutoffTime | cutoffTimeFix }}</p>
            </li>
            <li class="pickup-item">
              <p class="title">Pick-up number</p>
              <p class="desc">{{ sendInfo.pickupNum }}</p>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <bill-list />
  </div>
</template>

<style lang="less" scoped>
@import '~@/assets/css/main.less';
@import '~@/assets/fonts/font.less';
.order-placed {
  position: relative;
  min-height: 600px;
  .title {
    .font-regular;
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    line-height: 19px;
  }
  .step-desc {
    .font-light;
    font-weight: 300;
    padding-top: 10px;
    color: @app-body-color;
    span {
      margin-right: 20px;
    }
  }
  .steps {
    margin-top: 46px;
    .step {
      padding: 0 20px 36px;
      position: relative;
      border-left: 1px dashed @app-color;
      &:last-child {
        border-left: 0 dashed @app-color;
      }
      .f-number {
        .font-regular;
        position: absolute;
        display: inline-block;
        left: -8px;
        width: 16px;
        height: 16px;
        background-color: @app-color;
        border-radius: 16px;
        color: #fff;
        text-align: center;
        line-height: 16px;
      }
      .title {
        .font-regular;
        font-size: 14px;
        font-weight: 400;
        color: @app-black-color;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        label {
          .font-light;
        }
      }
      .desc {
        .font-light;
        padding-top: 10px;
        font-size: 12px;
        font-weight: 300;
        color: @app-body-color;
      }
      .info {
        .font-light;
        padding-top: 5px;
        font-size: 12px;
        font-weight: 300;
        color: @app-blue-color;
      }
    }
  }
  .box-status {
    border-radius: 4px;
    border: 1px solid #eeeff0;
    margin-top: 20px;
    .box-item {
      &:last-child,
      &.storing {
        .row {
          border-bottom: 0 solid #eeeff0;
        }
      }
      .row {
        margin: 0 24px;
        height: 90px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #eeeff0;
        &:last-child {
          .content {
            border-bottom: 0 solid #eeeff0;
          }
        }
        .num {
          .font-regular;
          width: 56px;
          font-size: 18px;
          font-weight: 400;
          color: #262626;
        }
        .content {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eeeff0;
          .content-row {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            line-height: 18px;
            .tip {
              .font-light;
              font-size: 14px;
              font-weight: 300;
              color: @app-body-color;
            }
            .number {
              .font-regular;
              font-size: 16px;
              font-weight: 400;
              padding-top: 10px;
              display: flex;
              align-items: center;
            }
            .btn {
              border-radius: 18px;
              .d-cion {
                font-size: 13px;
                margin-right: 6px;
              }
            }
          }
        }
      }
    }
  }
  .pickup-status {
    border-radius: 4px;
    border: 1px solid #eeeff0;
    margin-top: 20px;
    padding: 0 40px;
    .pickup-item {
      border-bottom: 1px solid #eeeff0;
      padding: 16px 0;
      &:last-child {
        border-bottom: 0 solid #eeeff0;
      }
      .title {
        .font-regular;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #262626;
        line-height: 20px;
      }
      .desc {
        .font-light;
        padding-top: 6px;
        height: 15px;
        font-size: 12px;
        font-weight: 300;
        color: #afb5c6;
        line-height: 15px;
      }
    }
  }
}
</style>
